import React, { Component } from 'react';
import axios from 'axios';
import { withRouter } from 'react-router-dom';
import Loader from '../helpers/loader';
import AppContext from '../app/AppContext';
import SocialLoginError from '../helpers/socialLoginError';

class GoogleLogIn extends Component {
    static contextType = AppContext;

    constructor (props) {
        super(props);

        this.state = {
            hasError: null,
        };
    }

    componentDidMount () {
        const googleCode = new URLSearchParams(window.location.search).get('code');
        const redirect_uri = `${process.env.REACT_APP_BASE_URL}/google-login`;
        const apiCallURL = `${process.env.REACT_APP_API_URL}/api/accounts/auth/login/google/`;
        axios
            .post(apiCallURL, {
                code: googleCode,
                claim: this.context.getClaimId(),
                redirect_uri,
            })
            .then(res => {
                localStorage.removeItem('claim');
                this.context.setUser(res.data.user);

                const {
                    membershipStatus,
                    defaultOrganisation,
                } = this.context.getMemberShipStatusAndDefaultOrganisation(res.data.user);
                if (sessionStorage.getItem('invite_code')) {
                    this.context.acceptTeamInvite(res);
                }
                else {
                    this.context.handleLogInState(res.data.token, membershipStatus, defaultOrganisation);
                    sessionStorage.getItem('next') && this.context.selectedOrganisation?.id ? 
                        this.props.history.push(sessionStorage.getItem('next')) : this.props.history.push('/create-organisation');

                    sessionStorage.removeItem('next');
                }
            })
            .catch(error => {
                console.log('error', error);
                console.log('Google login error', error?.response?.data);
                this.setState({
                    hasError: error?.response?.data?.message
                        ? error?.response?.data?.message
                        : 'An error occurred. Please try again later or contact our team at info@racecheck.com.',
                });
            });
    }

    render () {
        return (
            <div>
                {this.state.hasError ? (
                    <SocialLoginError errorMessage={this.state.hasError} />
                ) : (
                    <div className="social-login-loading-container">
                        <Loader />
                        <p>Using Google to log you in...</p>
                    </div>
                )}
            </div>
        );
    }
}

export default withRouter(GoogleLogIn);
